module.exports = __webpack_public_path__ + "static/media/2016-Mustang-Convertible-V8.d22dfd02.jpg";